<ChapterNav params="{params}" segment="abgeschlossen" />

{#if ch}
  <section class="section" id="chapter">
    <div class="container pt-5">
      <div class="has-text-centered mt-5 mb-5">
        <h2 class="is-size-3">
          {@html ch.title}
        </h2>
      </div>

      <ChapterFinishedContent />
    </div>
  </section>
{/if}

<script>
import { onMount } from "svelte";
import { currentChapter } from "./stores";

import ChapterNav from "./ChapterNav.svelte";
import ChapterFinishedContent from "./ChapterFinishedContent.svelte";

export let params = {};

let ch;

onMount(() => {
  currentChapter.subscribe((value) => {
    if (value == undefined) {
      return;
    }
    ch = value;
  });
});
</script>

<style type="text/scss">
</style>
